<template>
    <div class="argument">
      <div class="back" @click="back">
      <img src="@/assets/back.png" alt="返回" />
      返回
    </div>
        <iframe class="iframe" src="7-B授权委托书（单位-经办)通用勾选版20220111.pdf" allowtransparency="yes" width="100%" height="850" scrolling="no" frameborder="0"></iframe>
    </div>
</template>

<script>
export default {
  data() {
    return {
      visiable: false,
    };
  },
  methods: {
    show() {
      this.visiable = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.argument {
  padding: 0 20px;
  width: 900px;
  box-sizing: border-box;
  margin: 0 auto;
  .back {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 20px;
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #595959;
    line-height: 21px;
    cursor: pointer;
    img {
      width: 12px;
      height: 20px;
    }
  }
  .iframe{
      border: none;
  }
  }
</style>